import { gql } from "@apollo/client";

export const GET_ALERTS_BY_VM_ID = gql`
  query AlertsByVmId($vmId: ID!, $index: Int!) {
    alertsByVmId(vmId: $vmId, index: $index) {
      alerts {
        alertName
        occurredAt
        monitorCondition
        description
        vmName
        metricValue
        resolvedAt
        duration
      }
      vmName
      index
      hasNext
      hasPrevious
      totalCount
    }
  }
`;

export const GET_ALERT_SUMMARY = gql`
  query AlertSummary($vmId: ID!, $startDate: String!, $endDate: String!) {
    alertSummary(vmId: $vmId, startDate: $startDate, endDate: $endDate) {
      vmId
      vmName
      alertGroups {
        alertName
        count
      }
      firedCount
      resolvedCount
      totalCount
    }
  }
`;

export const GET_ALERT_HEATMAP = gql`
  query AlertHeatmap($vmId: ID!) {
    alertHeatmap(vmId: $vmId) {
      vmId
      vmName
      heatmapData {
        date
        count
      }
    }
  }
`;